import React, { useEffect, useState } from 'react';
import GalleryItem from './GalleryItem';

const Gallery = () => {
  const [displayCount, setDisplayCount] = useState(6);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
      fetch("gallery.json")
      .then((res) => res.json())
      .then((data) => setGallery(data))
  }, []);
  
  const showMoreItems = () => {
    setDisplayCount(gallery.length);
    setIsGalleryOpen(true);
  };
  
  const closeGallery = () => {
    setDisplayCount(6);
    setIsGalleryOpen(false);
  };

  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {gallery.slice(0, displayCount).map((gallery) => (
          <GalleryItem key={gallery._id} gallery={gallery} />
        ))}
      </div>
      {!isGalleryOpen && displayCount < gallery.length && (
        <div className='flex justify-center mt-4'>
          <button
            onClick={showMoreItems}
            className="text-xl mr-4"
          >
            See More
          </button>
        </div>
      )}
      {isGalleryOpen && (
        <div className='flex justify-center mt-4'>
          <button
            onClick={closeGallery}
            className="text-xl"
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
}

export default Gallery;
